import "./index.scss";
import { hackRoutes } from "@/mixin/parents-attach-first-child-config";

function skip_page(el) {
  let $el = $(el);
  let parent = el.parentElement;
  let skipPageHeight = $el.outerHeight();

  el.classList.remove("skip-page");
  $(window).scrollTop(skipPageHeight);
}

export default {
  install(Vue, options = {}) {
    Vue.directive("skip", {
      inserted: (el, { value }) => {
        if (Object.values(hackRoutes).includes(value)) {
          el.classList.add("skip-page");
          let parent = el.parentElement;

          //  transition动画
          if (~parent.className.indexOf("v-enter-active")) {
            $(window).one("page-change-ended", () => {
              skip_page(el);
            });
          } else {
            skip_page(el);
          }
        }
      },
      update: (el, { value }) => {},
    });
  },
};
